export default __webpack_public_path__ + "static/media/Potent Daggamalt.84eb9354.jpg";